import { render, staticRenderFns } from "./ApprovePOShare.vue?vue&type=template&id=74c60e1b"
import script from "./ApprovePOShare.vue?vue&type=script&lang=js"
export * from "./ApprovePOShare.vue?vue&type=script&lang=js"
import style0 from "./ApprovePOShare.vue?vue&type=style&index=0&id=74c60e1b&prod&lang=css"
import style1 from "./ApprovePOShare.vue?vue&type=style&index=1&id=74c60e1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports